// src/hooks/usePWAStatus.js
import { useEffect, useState } from "react";

export default function usePWAStatus() {
    const [isStandalone, setIsStandalone] = useState(false);

    useEffect(() => {
        const mqStandalone =
            window.matchMedia && window.matchMedia("(display-mode: standalone)").matches;
        const mqFullscreen =
            window.matchMedia && window.matchMedia("(display-mode: fullscreen)").matches;
        const iosStandalone = window.navigator.standalone === true; // iOS Safari
        const referrerAndroidTWA = document.referrer.startsWith("android-app://");

        setIsStandalone(mqStandalone || mqFullscreen || iosStandalone || referrerAndroidTWA);
    }, []);

    return { isStandalone };
}
